/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ClaimDocumentModel { 
    id: number;
    name: string;
    exportName?: string | null;
    claimId: number;
    evidenceDocumentId: number;
    note: string;
    /**
     * Optimistic concurrency token.
     */
    rowVersion: number;
}

